import { render, staticRenderFns } from "./mx-record-dialog.vue?vue&type=template&id=377344fe&scoped=true&"
import script from "./mx-record-dialog.vue?vue&type=script&lang=tsx&"
export * from "./mx-record-dialog.vue?vue&type=script&lang=tsx&"
import style0 from "./mx-record-dialog.vue?vue&type=style&index=0&id=377344fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377344fe",
  null
  
)

export default component.exports